/* ==========================================================================
   Product Card — Compare checkbox click isolation
   Stops clicks on the compare box/label from bubbling up to <product-card>,
   which has a click handler that navigates to the product page.
   ========================================================================== */
(function () {
  'use strict';

  // Capture phase so we beat the theme's click handler
  document.addEventListener(
    'click',
    function (e) {
      var compare = e.target.closest('.card__compare');
      if (compare) {
        e.stopPropagation();
      }
    },
    true
  );
})();